import React, {useEffect, useState} from 'react';
import {Controller} from 'react-hook-form';
import {TreePicker} from "rsuite";
import 'rsuite/dist/rsuite.min.css';

const findPathInTree = (treeData, value, path = []) => {
  if (value) {
    for (const node of treeData) {
      // Check if this node is the one we're looking for
      if (node?.value === value) {
        return path;
      }
      // If this node has children, recurse into them
      if (node?.children) {
        const foundPath = findPathInTree(node.children, value, [...path, node.value]);
        if (foundPath) {
          return foundPath;
        }
      }
    }
  }
  // If we've searched all nodes and haven't returned, this subtree doesn't contain the value
  return null;
};

export default function ({
                           label,
                           name,
                           control,
                           errorMessage,
                           options = [],
                           placeholder = 'აირჩიეთ',
                           inputClassName = '',
                           optionLabel = "name",
                           optionValue = "id",
                           callback = null,
                           required = false,
                           clearable = true,
                           defaultValue = '',
                           watch,
                         }) {

  const [selectedValue, setSelectValue] = useState(null);
  const [expandedKeys, setExpandedKeys] = useState([])

  const value = watch(name);

  useEffect(() => {
    if (options?.length > 0 && (!selectedValue || value !== selectedValue)) {
      setSelectValue(value);
      setExpandedKeys(findPathInTree(options, value) || [])
    }
  }, [options, value]);

  const handleChange = (selected, onChange) => {
    onChange(selected);
    setSelectValue(selected)
    setExpandedKeys(findPathInTree(options, selected))
    if (callback) callback(selected);
  }

  const handleExpand = (keys) => {
    setExpandedKeys(keys)
  }

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({field: {onChange}}) => (
          <div
            className={`fv-row mb-10${inputClassName ? " " + inputClassName : ""}`}
          >
            <label className="form-label fs-6 fw-bolder color-dark-grey">
              {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
            </label>
            <TreePicker
              appearance="subtle"
              size="sm"
              placeholder={placeholder}
              data={options}
              value={selectedValue}
              className="form-control form-control-sm form-control-solid"
              onChange={(selected) => handleChange(selected, onChange)}
              expandItemValues={expandedKeys || []}
              defaultValue={defaultValue}
              defaultExpandItemValues={findPathInTree(options, defaultValue) || []}
              onExpand={handleExpand}
              cleanable={clearable}
              labelKey={optionLabel}
              valueKey={optionValue}
            />
            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )}
      />
    </>
  )
}